export default __webpack_public_path__ + "static/media/powerBi.5a8392e7.png";